import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { ProductComponent } from './admin-dashboard/product/product.component';
import { ListProductComponent } from './admin-dashboard/product/list-product/list-product.component';
import { ListItemComponent } from './admin-dashboard/product/list-product/list-item/list-item.component';
import { AppRoutingModule } from './app.routing.module'
import { ProductService } from './admin-dashboard/product/product.service';
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { SignupComponent } from './auth/signup/signup.component';
import { SigninComponent } from './auth/signin/signin.component'
import { AuthService } from './services/auth.service';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AuthGaurd } from './services/auth-gaurd.service';
import { CompanySitesComponent } from './admin-dashboard/company-sites/company-sites.component';
import { CompanysitesService } from './admin-dashboard/company-sites/company-sites.service';
import { DetailSiteComponent } from './admin-dashboard/company-sites/detail-site/detail-site.component';
import { MaterialModule } from './material';
import { SiteSystemComponent } from './admin-dashboard/site-system/site-system.component'
import { SystemService } from './services/system.service';
import { VmMachineComponent } from './admin-dashboard/vm-machine/vm-machine.component';
import { ChannelListComponent } from './admin-dashboard/vm-machine/channel-list/channel-list.component';
import { EditChannelComponent } from './admin-dashboard/vm-machine/edit-channel/edit-channel.component';
import { VmMachineService } from './services/vm-machine.service';
import { HelpComponentComponent } from './admin-dashboard/help-component/help-component.component';
import { DialogDelete } from './dialog-delete/dialog-delete.component';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { TransactionViewComponent } from './admin-dashboard/site-system/records/transaction-view/transaction-view.component';
import { SpecialPricesComponent } from './admin-dashboard/special-prices/special-prices.component';
import { ConfigService } from './shared/config';
import { environment } from '../environments/environment';
// import { TimeAgoPipe } from 'time-ago-pipe';
import { ExcelService } from './shared/excel';

import { BlankcomponentComponent } from './admin-dashboard/company-sites/blankcomponent/blankcomponent.component';

import { NotifierModule } from 'angular-notifier';
import { NotificationService } from './shared/notification.service';
import { StockcontrollComponent } from './admin-dashboard/site-system/inventory/stockcontroll/stockcontroll.component';

import { SidebarComponent } from './sidebar/sidebar.component';
import { DetailSiteLayoutComponent } from './admin-dashboard/company-sites/detail-site-layout/detail-site-layout.component';
import { FatTopBarLayoutComponent } from './layout/fat-top-bar-layout/fat-top-bar-layout.component';
import { CompanySitesLayoutComponent } from './admin-dashboard/company-sites/company-sites-layout/company-sites-layout.component';
import { CompanySitesListComponent } from './admin-dashboard/company-sites/company-sites-list/company-sites-list.component';
import { CardViewLayoutComponent } from './layout/card-view-layout/card-view-layout.component';
import { CardViewSimpleCardComponent } from './layout/card-view-layout/card-view-simple-card/card-view-simple-card.component';
import { CardViewAddCardComponent } from './layout/card-view-layout/card-view-add-card/card-view-add-card.component';
import { CommonPopup } from './admin-dashboard/common-popup/common-popup';
import { SiteSystemLayoutComponent } from './admin-dashboard/site-system/site-system-layout/site-system-layout.component';
import { ReportGeneratorComponent } from './admin-dashboard/report-generator/report-generator.component';
import { ReportGeneratorResultComponent } from './admin-dashboard/report-generator/report-generator-result/report-generator-result.component';
import { ReportGeneratorService } from './admin-dashboard/report-generator/report-generator.service';
import { TableStandardLayoutComponent } from './layout/table-standard-layout/table-standard-layout.component';
import { AdminSettingComponent } from './admin-setting/admin-setting.component';
import { ApplicationStateService } from './shared/applicationState.service';
import { RxModelDirective } from './shared/rx-model-directive';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { SpinnerLoadingComponent } from './layout/spinner-loading/spinner-loading.component';
import { StockFillerComponent } from './admin-dashboard/site-system/inventory/stock-filler/stock-filler.component';
import { StockFillerDataPopupComponent } from './admin-dashboard/site-system/inventory/stock-filler/stock-filler-data-popup/stock-filler-data-popup.component';
import { SettingComponent } from './setting/setting.component';
import { CompanyUsersComponent } from './admin-setting/assing-company-users/company-users.component';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { CompanyUsersListComponent } from './admin-setting/assing-company-users/company-users-list/company-users-list.component';
import { UpdateCompanyInUserPopup } from './admin-setting/assing-company-users/company-users-list/update-company-in-user-popup/update-company-in-user-popup';
import { UpdateUserRolePopup } from './admin-setting/assing-company-users/company-users-list/update-user-role-popup/update-user-role-popup';

import { ContainerStandardComponent } from './layout/container-standard/container-standard.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

// import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
// import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { UpdateSitesPopup } from './admin-setting/assing-company-users/company-users-list/update-sites-popup/update-sites-popup';
import { InventoryComponent } from './admin-dashboard/site-system/inventory/inventory.component';
import { SubTopBarComponent } from './layout/sub-top-bar/sub-top-bar.component';
import { RecordsComponent } from './admin-dashboard/site-system/records/records.component';

// import { Ng2ImgMaxModule } from 'ng2-img-max';

import { TableViewPopup } from './import-table-maker/table-view-popup/table-view-popup.component';
import { ProductEditPopup } from './admin-dashboard/product/product-edit-popup/product-edit-popup';
import { ActionButtonsAcsses } from './shared/actionsButtonsAcesses.service';
import { HhButtonComponent } from './layout/hh-button/hh-button.component';
import { TResultViewComponent } from './admin-dashboard/site-system/records/transaction-view/t-result-view/t-result-view.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { AccessLevelsComponent } from './admin-setting/assing-company-users/company-users-list/access-levels/access-levels.component';
import { ListViewSimpleCardComponent } from './layout/card-view-layout/list-view-simple-card/list-view-simple-card.component';
import { OrdersComponent } from './admin-dashboard/orders/orders.component';
import { OrderDetailPopup } from './admin-dashboard/orders/order-detail-popup/order-detail-popup';
import { NotificationListComponent } from './admin-dashboard/notifications-list/notifications-list.component';
import { ExtraStockcontrollComponent } from './admin-dashboard/site-system/extra-inventory/extrastockcontroll/extrastockcontroll.component';
import { ActionLog } from './admin-dashboard/site-system/records/actions-log/actions-log.component';
import { LoggingHttpInterceptor } from './LogginHTTPIntercepter';
import { PlannerComponent } from './admin-dashboard/planner/planner.component';
import { CompanyReportGeneratorComponent } from './reports/company-report-generator/company-report-generator.component';
import { CompanyReportGeneratorResultComponent } from './reports/company-report-generator/company-report-generator-result/company-report-generator-result.component';
import { CompanyReportGeneratorService } from './services/company-report-generator.service';
import { MachineLog } from './admin-dashboard/site-system/records/machine-log/machine-log.component';
import { CategoryComponent } from './admin-dashboard/category/category.component';
import { SiteCategoryComponent } from './admin-dashboard/site-system/category/category.component';
import { SitesCategoryPopup } from './admin-dashboard/site-system/category/sites-category-popup/sites-category-popup';
import { CategoryDetailPopup } from './admin-dashboard/site-system/category/category-detail-popup/category-detail-popup';
import { ScheduledTaskComponent } from './admin-dashboard/scheculed-task/scheculed-task.component';
import { TaskDetailPopup } from './admin-dashboard/scheculed-task/task-detail-popup/task-detail-popup';
import { TimeDateService } from './shared/timeDate.service';
import { ReguleringService } from './admin-dashboard/regulering/regulering.service';
import { ReguleringComponent } from './admin-dashboard/regulering/regulering.component';
import { ReguleringPopupComponent } from './admin-dashboard/regulering/regulering-popup/regulering-popup.component';
import { LinksComponent } from './admin-dashboard/site-system/inventory/links/links.component';
import { ApplyChangesDetailComponent } from './admin-dashboard/regulering/applyChangesDetail-popup/applyChangesDetail-popup.component';
import { OverviewComponent } from './admin-dashboard/overview/overview.component';
import { HttpClientModule } from '@angular/common/http';
import { ActionButtonToolbarComponent } from './layout/action-button-toolbar/action-button-toolbar.component';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// icons
import { MembershipV2Component } from './admin-dashboard/membership-v2/membership-v2.component';
import { EmployeeDialogComponent } from './admin-dashboard/membership-v2/dialogs/employee-dialog.component';
import { GroupDialogComponent } from './admin-dashboard/membership-v2/dialogs/group-dialog.component';
import { LedgerDialogComponent } from './admin-dashboard/membership-v2/dialogs/ledger-dialog.component';
import { CreditDialogComponent } from './admin-dashboard/membership-v2/dialogs/credit-dialog.component';
import { ImportEmployeesDialogComponent } from './admin-dashboard/membership-v2/dialogs/import-employees-dialog.component';
import { ResetPasswordDialogComponent } from './admin-dashboard/membership-v2/dialogs/reset-password-dialog.component';
import { EmployeesGlobalComponent } from './admin-dashboard/employees-global/employees-global.component';
import { CustomerMappingComponent } from './admin-dashboard/customer-mapping/customer-mapping.component';
import { BillingComponent } from './admin-dashboard/billing/billing.component';
import { PortalAccessComponent } from './admin-dashboard/portal-access/portal-access.component';
import { ContactBookComponent } from './admin-dashboard/contact-book/contact-book.component';
import { PowerOfficeLogComponent } from './admin-dashboard/poweroffice-log/poweroffice-log.component';
import { ParentRefundsComponent } from './admin-dashboard/parent-refunds/parent-refunds.component';
import { DeliveryOverviewComponent } from './admin-dashboard/delivery/overview/overview.component';
import { DeliveryRoutesComponent } from './admin-dashboard/delivery/routes/routes.component';
import { DeliveryDriversComponent } from './admin-dashboard/delivery/drivers/drivers.component';
import { DeliveryDispatchComponent } from './admin-dashboard/delivery/dispatch/dispatch.component';
import { GuideDialogComponent } from './admin-dashboard/delivery/guide-dialog/guide-dialog.component';
import { DeliveryIssuesComponent } from './admin-dashboard/delivery/issues/issues.component';
import { GarantiomsetningComponent } from './admin-dashboard/garantiomsetning/garantiomsetning.component';
import { CoffeeMachinesComponent } from './admin-dashboard/coffee-machines/coffee-machines.component';
import { AppCategoryContentComponent, KantineOverviewComponent } from './admin-dashboard/overview/kantine-overview/kantine-overview.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef } from '@angular/material/dialog';
import { SvinnComponent } from './admin-dashboard/site-system/inventory/svinn/svinn.component';
import { AppTicketsComponent } from './admin-dashboard/overview/kantine-overview/tickets/tickets.component';
import { SvinnReportService } from './services/svinn-report.service';
import { SvinnReportComponent } from './admin-dashboard/svinn-report/svinn-report.component';
import { Iframe } from './shared/iframe';
import { SalesReportComponent } from './reports/sales-report/sales-report.component';
import { SalesReportService } from './services/sales-report.service';
import { SaleReportGeneratorResultComponent } from './reports/sales-report/report-generator-result/sale-report-generator-result.component';
import { AppPeiChartComponent } from './reports/sales-report/piechart/peichart.component';
import { AppStackedChartComponent } from './reports/sales-report/stackedChart/stackedChart.component';
import { AppbarChartComponent } from './reports/sales-report/barChart/barChart.component';
import { JSDLog } from './admin-dashboard/site-system/records/jsd-logs/jsd-log.component';
import { AppStackedBarChartComponent } from './reports/sales-report/stackedBarChart/stackedBarChart.component';
import { AppLineChartComponent } from './reports/sales-report/lineChart/lineChart.component';
import { AppSaleSvinnComponent } from './reports/sales-report/sale-svinn/sale-svinn.component';
import { SubscriptionService } from './services/kampanje.service';
import { KampanjeCategoryFormComponent } from './admin-dashboard/kampanje/kampanje-category-card/kampanje-category-form.component';
import { KampanjeListComponent } from './admin-dashboard/kampanje/kampanje-list.component';
import { AnnouncementFormComponent } from './admin-dashboard/announcement/announcement-card/announcement-form.component';
import { AnnouncementListComponent } from './admin-dashboard/announcement/announcement-list.component';
import { AnnouncementService } from './services/announcement.service';
import { ReportsComponent } from './reports/reports.component';
import { OrderReportComponent } from './reports/order-report/order-report.component';
import { RevenueReportComponent } from './reports/revenue-report/revenue-report.component';
import { SystemInfoComponent } from './admin-dashboard/system-info/system-info.component';
import { SystemInfoService } from './services/system-info.service';
import { SystemInfoPopup } from './admin-dashboard/system-info/system-info-popup/system-info-popup';
import { KundekortComponent } from './admin-dashboard/kunde-kort/kunde-kort.component';
import { KundeKortBoardComponent } from './admin-dashboard/kunde-kort/kunde-kort-board/kunde-kort-board.component';
import { MyTasksComponent } from './admin-dashboard/my-tasks/my-tasks.component';
import { KundeKortService } from './services/kunde-kort.service';
import { AddContactPersonDialog, AddDriftAvtaleDialog, AddMoteReferatDialog, AddNotaterDialog, AddTaskDialog, KundekortInfoPopup } from './admin-dashboard/kunde-kort/kunde-kort-popup/kunde-kort-info-popup';
import { MenuComponent } from './stocking/menus/menu/menu.component';
import { MenusComponent } from './stocking/menus/menus.component';
import { MenuCopyDialogComponent } from './stocking/menus/menu-copy-dialog/menu-copy-dialog.component';
import { SystemStockingConfigComponent } from './stocking/system-stocking-config/system-stocking-config.component';
import { ProductTypesComponent } from './stocking/product-types/product-types.component';
import { ExtraDeliveryComponent } from './stocking/extra-delivery/extra-delivery.component';
import { NewDeliveryDialogComponent } from './stocking/extra-delivery/new-delivery-dialog/new-delivery-dialog.component';
import { ApproveDeliveryDialogComponent } from './stocking/extra-delivery/approve-delivery-dialog/approve-delivery-dialog.component';
import { EmailComponent } from './admin-setting/email/email.component';
import { EmailDialogComponent } from './admin-setting/email/email-dialog/email-dialog.component';
import { SimListComponent } from './support/sim-list/sim-list.component';
import { CardViewSystemCardComponent } from './layout/card-view-layout/card-view-system-card/card-view-system-card.component';
import { ShellComponent } from './support/shell/shell.component';
import { MatDialogModule } from '@angular/material/dialog';
import { RefundReasonDialogComponent } from './admin-dashboard/orders/refund-reason-dialog/refund-reason-dialog.component';
import { AuditReasonDialogComponent } from './shared/audit-reason-dialog/audit-reason-dialog.component';
import { AuditLogsComponent } from './admin-dashboard/audit-logs/audit-logs.component';
import { KioskTabletsComponent } from './admin-dashboard/kiosk-tablets/kiosk-tablets.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { CategoryEditPopupComponent } from './admin-dashboard/category/category-edit-popup/category-edit-popup.component';
import { InventoryDetailsComponent } from './admin-dashboard/inventory-details/inventory-details.component';
import { NgTerminalModule } from 'ng-terminal';
import { SvinnReportPopupComponent } from './admin-dashboard/svinn-report/svinn-report-popup/svinn-report-popup.component';
import { ScheculedTaskService } from './services/scheculed-task.service';
import { ServicePopupComponent } from './support/service-popup/service-popup.component';
import { ServiceLogComponent } from './support/service-log/service-log.component';
import { ImageNameDialogComponent } from './support/shell/image-name-dialog/image-name-dialog.component';
import { FileUploadDialogComponent } from './support/shell/file-upload-dialog/file-upload-dialog.component';
import { FileDownloadDialogComponent } from './support/shell/file-download-dialog/file-download-dialog.component';
import { AuthenticatedIframeWrapperComponent } from './shared/authenticated-iframe-wrapper/authenticated-iframe-wrapper.component';
import { GrafanaReportOrdersComponent } from './reports/grafana-report-orders/grafana-report-orders.component';
import { GrafanaSupportDashboardsComponent } from './reports/grafana-support-dashboards/grafana-support-dashboards.component';
import { SystemPosterComponent } from './system-poster/system-poster.component';
import { AlarmListComponent } from './support/alarm-list/alarm-list.component';
import { CouponsModule } from './coupons/coupons.module';
import { CouponsListComponent } from './coupons/coupons-list/coupons-list.component';
import { CouponDialogComponent } from './coupons/coupon-dialog/coupon-dialog.component';
import { CouponStatsComponent } from './coupons/coupon-stats/coupon-stats.component';
import { TimeSelectorDialogComponent } from './support/service-popup/time-selector-dialog.component';
import { SelectionDialogComponent } from './support/service-popup/selection-dialog/selection-dialog.component';
import { SystemListComponent } from './system-list/system-list.component';

export const MY_MOMENT_FORMATS = {
  parseInput: 'l LT',
  fullPickerInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
  declarations: [
    AppComponent,
    AdminDashboardComponent,
    ProductComponent,
    ListProductComponent,
    ListItemComponent,
    ChannelListComponent,
    SignupComponent,
    SigninComponent,
    CompanySitesComponent,
    DetailSiteComponent,
    SiteSystemComponent,
    VmMachineComponent,
    EditChannelComponent,
    HelpComponentComponent,
    DialogDelete,
    TransactionViewComponent,
    SpecialPricesComponent,
    KantineOverviewComponent,
    CategoryComponent,
    CategoryEditPopupComponent,
    BlankcomponentComponent,
    StockcontrollComponent,
    SidebarComponent,
    SiteCategoryComponent,
    ActionLog,
    MachineLog,
    DetailSiteLayoutComponent,
    FatTopBarLayoutComponent,
    CompanySitesLayoutComponent,
    CompanySitesListComponent,
    CardViewLayoutComponent,
    CardViewSimpleCardComponent,
    ListViewSimpleCardComponent,
    CardViewAddCardComponent,
    CommonPopup,
    SystemInfoComponent,
    NotificationListComponent,
    SiteSystemLayoutComponent,
    ReportGeneratorComponent,
    CompanyReportGeneratorComponent,
    SalesReportComponent,
    CompanyReportGeneratorResultComponent,
    ReportGeneratorResultComponent,
    TableStandardLayoutComponent,
    SvinnComponent,
    MembershipV2Component,
    EmployeeDialogComponent,
    GroupDialogComponent,
    LedgerDialogComponent,
    CreditDialogComponent,
    ImportEmployeesDialogComponent,
    ResetPasswordDialogComponent,
    EmployeesGlobalComponent,
    CustomerMappingComponent,
    BillingComponent,
    PortalAccessComponent,
    ContactBookComponent,
    PowerOfficeLogComponent,
    ParentRefundsComponent,
    DeliveryOverviewComponent,
    DeliveryRoutesComponent,
    DeliveryDriversComponent,
    DeliveryDispatchComponent,
    GuideDialogComponent,
    DeliveryIssuesComponent,
    GarantiomsetningComponent,
    CoffeeMachinesComponent,
    AdminSettingComponent,
    RxModelDirective,
    NotFoundPageComponent,
    SpinnerLoadingComponent,
    StockFillerComponent,
    StockFillerDataPopupComponent,
    UpdateSitesPopup,
    SettingComponent,
    CompanyUsersComponent,
    CompanyUsersListComponent,
    UpdateCompanyInUserPopup,
    UpdateUserRolePopup,
    ContainerStandardComponent,
    ExtraStockcontrollComponent,
    InventoryComponent,
    SubTopBarComponent,
    RecordsComponent,
    TableViewPopup,
    ProductEditPopup,
    HhButtonComponent,
    TResultViewComponent,
    ForgotComponent,
    AccessLevelsComponent,
    StockFillerComponent,
    OrdersComponent,
    OrderDetailPopup,
    RefundReasonDialogComponent,
    AuditReasonDialogComponent,
    AuditLogsComponent,
    KioskTabletsComponent,
    TaskDetailPopup,
    SitesCategoryPopup,
    CategoryDetailPopup,
    ReguleringPopupComponent,
    PlannerComponent,
    OrderReportComponent,
    RevenueReportComponent,
    CategoryComponent,
    ScheduledTaskComponent,
    ReguleringComponent,
    ApplyChangesDetailComponent,
    ActionButtonToolbarComponent,
    LinksComponent,
    OverviewComponent,
    DialogDelete,
    CommonPopup,
    StockFillerDataPopupComponent,
    UpdateCompanyInUserPopup,
    JSDLog,
    UpdateUserRolePopup,
    UpdateSitesPopup,
    TaskDetailPopup,
    SitesCategoryPopup,
    TableViewPopup,
    ReguleringPopupComponent,
    ProductEditPopup,
    AccessLevelsComponent,
    OrderDetailPopup,
    CategoryDetailPopup,
    Iframe,
    ApplyChangesDetailComponent,
    AppCategoryContentComponent,
    AppTicketsComponent,
    SvinnReportComponent,
    SaleReportGeneratorResultComponent,
    AppbarChartComponent,
    AppStackedBarChartComponent,
    AppPeiChartComponent,
    AppStackedChartComponent,
    AppLineChartComponent,
    AppSaleSvinnComponent,
    KampanjeCategoryFormComponent,
    KampanjeListComponent,
    AnnouncementFormComponent,
    AnnouncementListComponent,
    ReportsComponent,
    SystemInfoPopup,
    KundekortComponent,
    KundeKortBoardComponent,
    MyTasksComponent,
    KundekortInfoPopup,
    AddNotaterDialog,
    AddTaskDialog,
    AddContactPersonDialog,
    AddDriftAvtaleDialog,
    AddMoteReferatDialog,
    MenuComponent,
    MenusComponent,
    MenuCopyDialogComponent,
    SystemStockingConfigComponent,
    ProductTypesComponent,
    ExtraDeliveryComponent,
    NewDeliveryDialogComponent,
    ApproveDeliveryDialogComponent,
    EmailComponent,
    EmailDialogComponent,
    SimListComponent,
    CardViewSystemCardComponent,
    ShellComponent,
    InventoryDetailsComponent,
    SvinnReportPopupComponent,
    ServicePopupComponent,
    ServiceLogComponent,
    ImageNameDialogComponent,
    FileUploadDialogComponent,
    FileDownloadDialogComponent,
    AuthenticatedIframeWrapperComponent,
    GrafanaReportOrdersComponent,
    GrafanaSupportDashboardsComponent,
    SystemPosterComponent,
    AlarmListComponent,
    CouponsListComponent,
    CouponDialogComponent,
    CouponStatsComponent,
    TimeSelectorDialogComponent,
    SelectionDialogComponent,
    SystemListComponent
  ],

  imports: [
    // TimeAgoPipe,
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatSelectModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    // AngularFirestoreModule.enablePersistence({experimentalTabSynchronization: true}),
    AngularFirestoreModule,
    AngularFireAuthModule,
    MaterialModule,
    AngularFireStorageModule,
    NgApexchartsModule,
    NotifierModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    NgTerminalModule,
    CouponsModule
    // OwlDateTimeModule,
    // OwlMomentDateTimeModule,
    // Ng2ImgMaxModule,


  ],
  providers: [
    ProductService,
    AuthService,
    AuthGaurd,
    KundeKortService,
    CompanysitesService,
    SystemService,
    ReguleringService,
    VmMachineService,
    SalesReportService,
    ConfigService,
    ExcelService,
    NotificationService,
    ReportGeneratorService,
    ScheculedTaskService,
    ApplicationStateService,
    TimeDateService,
    SubscriptionService,
    CompanyReportGeneratorService,
    ActionButtonsAcsses,
    SvinnReportService,
    SystemInfoService,
    AnnouncementService,
    { provide: MAT_DATE_LOCALE, useValue: 'nb-NO' },
    // { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    // {provide: OWL_DATE_TIME_LOCALE, useValue: 'nb-NO'},
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },

    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }

  ],
  bootstrap: [
    AppComponent
  ],

})
export class AppModule { }
